import {
  getCascadeGatewayFeatures,
  getRemoteDiagnosticsFeature,
  getVitocal200SGatewayFeatures,
  getVitocal222SGatewayFeatures,
  getVitocal252GatewayFeatures,
  getVitoden300GatewayFeatures,
  getVitodens343FGatewayFeatures,
  getVitodens200GatewayFeatures,
  getVitovalorPTSGatewayFeatures,
  getVitodens100WGatewayFeatures,
  getVitochargeGatewayFeatures,
  getVitoligno300CGatewayFeatures,
  getVitoairGatewayFeatures,
  getVitosetAquaGatewayFeatures,
  getDefaultGatewayFeatures,
} from './operational-data.gateway.features.mocks';

export class MockedGatewayFeatures {
  mock(installationId: number, gatewaySerial: string) {
    let features = [];
    features = features.concat(getDefaultGatewayFeatures(installationId, gatewaySerial));

    switch (gatewaySerial) {
      case '7736170-gw-serial-17':
        features = features.concat(getCascadeGatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '7637415001667188':
        features = features.concat(getVitoden300GatewayFeatures(installationId, gatewaySerial));
        break;

      case '7571381-gw-serial':
        features = features.concat(getVitoden300GatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '7637416-gw-serial':
        features = features.concat(getVitocal252GatewayFeatures(installationId, gatewaySerial));
        break;

      case '7637410-gw-serial-16':
        features = features.concat(getVitocal222SGatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '7724820-gw-serial-18':
        features = features.concat(getVitodens200GatewayFeatures(installationId, gatewaySerial));
        break;

      case '7637415-gw-serial':
        features = features.concat(getVitocal200SGatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '7782093-gw-serial':
        features = features.concat(getVitovalorPTSGatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '7571381-gw-serial-4':
        features = features.concat(getVitodens343FGatewayFeatures(installationId, gatewaySerial));
        break;

      case '7637414-gw-serial':
        features = features.concat(getVitodens100WGatewayFeatures(installationId, gatewaySerial));
        break;

      case '7637419-gw-serial':
        features = features.concat(getVitocal200SGatewayFeatures(installationId, gatewaySerial));
        break;

      case '7724827-gw-serial':
        features = features.concat(getVitochargeGatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '77820930-gw-serial-10':
        features = features.concat(getVitochargeGatewayFeatures(installationId, gatewaySerial));
        break;

      case '7637221-gw-serial-11':
        features = features.concat(getVitoligno300CGatewayFeatures(installationId, gatewaySerial));
        break;

      case '7949720-gw-serial-14':
        features = features.concat(getVitoairGatewayFeatures(installationId, gatewaySerial));
        features.push(getRemoteDiagnosticsFeature(installationId, gatewaySerial));
        break;

      case '7736172-gw-serial-12':
      case '7949719-gw-serial-12':
        features = features.concat(getVitosetAquaGatewayFeatures(installationId, gatewaySerial));
        break;

      default:
        break;
    }

    return features;
  }
}
